import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const renderSummary = item => {
    if (!item.summary && !item.summaryHtml) return null;

    if (item.summaryHtml) {
        return <div className={styles.summary} dangerouslySetInnerHTML={{ __html: item.summaryHtml }} />;
    }

    return <p className={styles.summary}>{item.summary}</p>;
};

const FinanceFlash = ({ content = {} }) => {
    const { list = [], moreUrl = 'https://original.ifeng.com/finance/fastnews' } = content;

    if (!list.length) return null;

    return (
        <section className={styles.card} aria-labelledby="finance-flash-title" data-nosnippet>
            <div className={styles.head}>
                <h2 id="finance-flash-title" className={styles.title}>
                    财经快讯
                </h2>
            </div>
            <ul className={styles.list}>
                {list.map(item => (
                    <li key={item.id} className={styles.item}>
                        <a href={item.listUrl} className={styles.link} target="_blank" rel="noopener noreferrer">
                            <div className={styles.itemMain}>
                                <div className={styles.itemTitle}>{item.title}</div>
                                {renderSummary(item)}
                                {item.tags && item.tags.length ? (
                                    <div className={styles.tagList}>
                                        {item.tags.map(tag => (
                                            <span key={tag} className={styles.tagItem}>
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                ) : null}
                                {item.time ? <time className={styles.time}>{item.time}</time> : null}
                            </div>
                            {item.thumbnail ? (
                                <div className={styles.thumbBox}>
                                    <img className={styles.thumb} src={item.thumbnail} alt="" loading="lazy" />
                                </div>
                            ) : null}
                        </a>
                    </li>
                ))}
            </ul>
            <a href={moreUrl} className={styles.moreBtn} target="_blank" rel="noopener noreferrer">
                查看更多
            </a>
        </section>
    );
};

FinanceFlash.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(FinanceFlash);
